import { Component } from '@angular/core';
import { UndeliveredReasonsCreateComponent } from '../../../../components/admin-dashboard-component/undelivered-reasons-component/undelivered-reasons-create-component/undelivered-reasons-create-component';

@Component({
  selector: 'app-undelivered-reasons-create-page',
  standalone: true,
  imports: [UndeliveredReasonsCreateComponent],
  templateUrl: './undelivered-reasons-create.html',
  styleUrl: './undelivered-reasons-create.scss',
})
export class UndeliveredReasonsCreate {}